import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';


@Injectable()
export class FormValidatorHelper {
    constructor() { }

    public getFormValidationErrors(form) {

        const result = [];
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            const nestedControl = form.get(key)?.controls;

            if (nestedControl) {
                Object.keys(nestedControl).forEach(control => {
                    if (nestedControl[control]['errors']) {

                        result.push({
                            'control': key,
                            'error': nestedControl[control]['errors'],
                            'value': control
                        });
                    }
                });
            }
            if (controlErrors) {
                Object.keys(controlErrors).forEach(keyError => {
                    result.push({
                        'control': key,
                        'error': keyError,
                        'value': controlErrors[keyError]
                    });
                });
            }
        });

        return result;
    }

}